import { createClient } from '@supabase/supabase-js';

const environment = import.meta.env as Record<string, string | undefined>;
const url = environment.VITE_SUPABASE_URL?.trim();
const anonKey = environment.VITE_SUPABASE_ANON_KEY?.trim();

export const configured = Boolean(url && anonKey);
export const cloudStatus = configured
  ? 'Cloud er konfigureret. Forbindelse og adgang kontrolleres ved login.'
  : 'Lokal tilstand. Tilføj Supabase URL og offentlig anon-nøgle for at aktivere login og cloud.';

// Only the public anon key belongs in a browser bundle. RLS protects account data.
export const supabase = configured
  ? createClient(url!, anonKey!, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null;
